import { BaseEntity } from '../base-entity';
import { Dataset } from './dataset';
import { PbiDatasetRefresh } from './pbi-dataset-refresh';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

export interface RefreshFailureIssueLink {
  id: string;
  createdAt: Date;
  datasetId?: string;
  datasetIdSnapshot: string;
  datasetNameSnapshot: string;
  issueNodeId: string;
  issueNumber: number;
  lastUpdatedBy: string;
  lastUpdatedDate: Date;
  pbiDatasetRefreshId?: string;
  recoveredAt?: Date;
  retiredAt?: Date;
  supersededAt?: Date;
  templateWorkspaceNameSnapshot: string;
  tenantKey: string;
  workspaceQualifierSnapshot: string;
  dataset: Dataset;
  pbiDatasetRefresh: PbiDatasetRefresh;
}

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class RefreshFailureIssueLink extends BaseEntity {
  /// <code> Place custom code between <code> tags
  /// </code>
  // Generated code. Do not place code below this line.
}
